import { init } from '@/common/EEContext';
import React from 'react';
import type { DecisionGraph } from "@imminently/decisively-core";

export type StoreState = {
  baselineDebugPayload: Record< string, unknown >;
  latestDebugPayload: StoreState[ 'baselineDebugPayload' ]
};
export const defaultState: StoreState = {
  baselineDebugPayload: {},
  latestDebugPayload: {},
};

export const DebugEEContextNS = init(defaultState);
DebugEEContextNS.WithCtx.displayName = 'release/Debug/EEContext/WithCtx';

// ===================================================================================

type BaseT = StoreState[ 'baselineDebugPayload' ]
export type DebugPayloadUtils = {
  useChange: () => (v: BaseT) => unknown;
  useReset: () => (transferLatestToBase?: true) => unknown
};
export const debugPayloadUtils: DebugPayloadUtils = {
  useChange: () => {
    const update = DebugEEContextNS.useUpdate();

    return React.useCallback < ReturnType< DebugPayloadUtils[ 'useChange' ] > >(
      v => void update(draft => {
        if(Object.keys(draft.baselineDebugPayload).length === 0) {

          draft.baselineDebugPayload = v;
        }


        draft.latestDebugPayload = v;
      }),
      [update],
    );
  },
  useReset: () => {
    const update = DebugEEContextNS.useUpdate();

    return React.useCallback < ReturnType< DebugPayloadUtils[ 'useReset' ] > >(
      transferLatestToBase => void update(draft => {

        draft.baselineDebugPayload = transferLatestToBase
          ? draft.latestDebugPayload
          : defaultState.baselineDebugPayload;


        draft.latestDebugPayload = defaultState.latestDebugPayload;
      }),
      [update],
    );
  },
};

export function replaceIdsWithDescriptions(
  data: Record< string, unknown>,
  graph: DecisionGraph,
): typeof data {
  return Object.keys(data).reduce(
    (a, id) => {
      const nodeId = graph.ref(id);
      const key = (nodeId !== undefined && graph.isListed(nodeId) && graph.field(nodeId, "description") as string) || id;


      a[ key ] = data[ id ];
      return a;
    },
    {},
  );
}

/** The id of the first node with this description. */
const idForDescription = (graph: DecisionGraph, description: string): string | undefined => {
  const nodeId = graph.nodesByDescription(description)[0];
  return nodeId === undefined ? undefined : graph.field(nodeId, "id") as string | undefined;
};

export function replaceDescriptionWithIds(
  data: Record< string, unknown>,
  graph: DecisionGraph
): typeof data {
  return Object.keys(data).reduce(
    (a, desc) => {
      const key = idForDescription(graph, desc) || desc;


      a[ key ] = data[ desc ];
      return a;
    },
    {},
  );
}
// ===================================================================================

// (DebugEEContextNS.ctx.Consumer as any)._currentValue.subscribe(s => {
//   console.log(5555, s.baselineDebugPayload, s.latestDebugPayload);
// });
